export const state = {
  current: null,
  currentMembers: [],
  currentProjectMembers: [],
  currentInvites: [],
  pendingInvites: [],
  orgs: [],
  selectedOrg: null, // org id,
  apikeys: []
}
